import api from './api';

export const getCurrencies = async () => {
  const { data } = await api.get('/currencies');
  return data;
};

export const createCurrency = async (name, value) => {
  const { data } = await api.post('/currencies', { name, value });
  return data;
};

export const updateCurrency = async (id, params) => {
  const { data } = await api.put(`/currencies/${id}`, params);
  return data;
};

export const deleteCurrency = async (id) => {
  const { data } = await api.delete(`/currencies/${id}`);
  return data;
};
